import useSWR from "swr";
import { toast } from "sonner";
import { Flame } from "lucide-react";
import { api, errText, fetcher, fmt, fmtPx, pairLabel } from "@/lib/api";

function Col({ title, rows, tone, onAnalyze, onSelect }) {
  return (
    <div className="flex-1 min-w-0">
      <div className={`text-[10px] font-semibold mb-1 ${tone}`}>{title}</div>
      <div className="space-y-0.5">
        {rows.map((r) => (
          <div key={r.symbol} className="flex items-center justify-between gap-1 text-[10px] rounded px-1 py-0.5 hover:bg-[#1e2329] cursor-pointer" onClick={() => onSelect?.(r.symbol)} data-testid={`mover-${r.symbol}`}>
            <span className="text-white font-semibold truncate">{pairLabel(r.symbol)}{r.selected && <span className="text-[#fcd535]" title="selected market"> ●</span>}</span>
            <span className={`mono ${r.change_pct >= 0 ? "up" : "down"}`}>{r.change_pct >= 0 ? "+" : ""}{fmt(r.change_pct, 1)}%</span>
            <span className="mono text-[#5e6673] hidden sm:inline">{fmtPx(r.price)}</span>
            <button onClick={(e) => { e.stopPropagation(); onAnalyze(r.symbol); }} className="text-[9px] text-[#fcd535] hover:underline shrink-0" data-testid={`mover-analyze-${r.symbol}`}>analyze</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export function MoversPanel({ onSelect }) {
  const { data } = useSWR("/market/movers?limit=6", fetcher, { refreshInterval: 60000 });
  const analyze = async (sym) => {
    toast.info(`Analyzing ${pairLabel(sym)}…`);
    try { const { data: d } = await api.post(`/analyze?symbol=${sym}`); const s = Array.isArray(d) ? d[0] : d; toast[s.action === "HOLD" ? "info" : "success"](`${pairLabel(sym)}: ${s.action} @ ${Math.round((s.confidence || 0) * 100)}% · ${s.status}`); } catch (e) { toast.error(errText(e)); }
  };
  if (!data) return null;
  return (
    <div className="panel p-2" data-testid="movers-panel">
      <div className="flex items-center justify-between px-1 mb-1">
        <div className="flex items-center gap-1.5"><Flame size={12} className="text-[#fcd535]" /><div className="panel-title">24h movers · gainers & losers</div></div>
        <span className="text-[9px] text-[#5e6673]" data-testid="movers-autopilot-note">{data.autopilot_enabled ? "autopilot scans these" : "● = selected"}</span>
      </div>
      <div className="flex gap-2 px-1">
        <Col title="TOP GAINERS" rows={data.gainers} tone="text-[#0ecb81]" onAnalyze={analyze} onSelect={onSelect} />
        <Col title="TOP LOSERS" rows={data.losers} tone="text-[#f6465d]" onAnalyze={analyze} onSelect={onSelect} />
      </div>
    </div>
  );
}
